/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiArElementFromJSON, StreemApiArElementToJSON, } from './';
export function StreemApiArtifactStreemshotRevisionFromJSON(json) {
    return StreemApiArtifactStreemshotRevisionFromJSONTyped(json, false);
}
export function StreemApiArtifactStreemshotRevisionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'revisionNumber': !exists(json, 'revision_number') ? undefined : json['revision_number'],
        'streemshotSid': !exists(json, 'streemshot_sid') ? undefined : json['streemshot_sid'],
        'storageUrl': !exists(json, 'storage_url') ? undefined : json['storage_url'],
        'arElements': !exists(json, 'ar_elements') ? undefined : (json['ar_elements'].map(StreemApiArElementFromJSON)),
        'url': !exists(json, 'url') ? undefined : json['url'],
        'edited': !exists(json, 'edited') ? undefined : json['edited'],
        'deletedAt': !exists(json, 'deleted_at') ? undefined : (new Date(json['deleted_at'])),
    };
}
export function StreemApiArtifactStreemshotRevisionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'revision_number': value.revisionNumber,
        'streemshot_sid': value.streemshotSid,
        'storage_url': value.storageUrl,
        'ar_elements': value.arElements === undefined ? undefined : (value.arElements.map(StreemApiArElementToJSON)),
        'url': value.url,
        'edited': value.edited,
        'deleted_at': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
    };
}
//# sourceMappingURL=StreemApiArtifactStreemshotRevision.js.map